import React from 'react';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getCpoPath } from 'client/data/models/cpo';
import { Link } from 'site-modules/shared/components/link/link';

import './browse-cpo-by-type.scss';

function BrowseCpoByTypeCarouselItem({ item }) {
  return (
    <Link
      to={item.metadata('url').value()}
      className="cpo-type-card h-100 d-flex flex-column align-items-center justify-content-between"
      style={{ minWidth: '140px' }}
      data-tracking-id="type_select"
      data-tracking-value={item.metadata('trackingValue').value()}
    >
      <div className="d-flex align-items-end">
        <img
          src={getStaticImageUrl(item.metadata('image').value())}
          alt=""
          className="w-100"
          style={{ minHeight: '48px' }}
        />
      </div>
      <div className="mt-1 h-100 d-flex align-items-center text-center fw-bold">{item.metadata('name').value()}</div>
    </Link>
  );
}

BrowseCpoByTypeCarouselItem.propTypes = {
  item: CmsEntities.Content.isRequired,
};

export function BrowseCpoByTypeUI({ browseByTypes = DEFAULT_CONTENT }) {
  const title = browseByTypes.title || 'Browse CPO by type';
  const types = browseByTypes.children();
  if (!types.length) {
    return null;
  }

  return (
    <div className="browse-cpo-by-type mt-3_5 mb-3_5" data-tracking-parent="edm-entry-type-center">
      <div className="heading-3 mb-2 mb-md-1_5" id="browse-cpo-by-type-list">
        {title}
      </div>
      <ul
        className="d-flex justify-content-between flex-nowrap list-unstyled text-gray-darker pb-1"
        aria-labelledby="browse-cpo-by-type-list"
        style={{ columnGap: '32px' }}
      >
        {browseByTypes.children().map(item => (
          <li className="p-0" key={item.id}>
            <BrowseCpoByTypeCarouselItem item={item} />
          </li>
        ))}
      </ul>
    </div>
  );
}

BrowseCpoByTypeUI.propTypes = {
  browseByTypes: CmsEntities.Content,
};

export const BrowseCpoByType = connectToModel(BrowseCpoByTypeUI, {
  browseByTypes: bindToContent(getCpoPath(), 'browse-by-type'),
});
